export const capitalizeFirstLetter = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);